import { AgGridReact } from "ag-grid-react"
import { SBAAutoComplete, SBAComboBox, SBADropDown, SBAMultiSelectCheck } from "../../../UiComponents/SBADropDown"
import { SBDatePicker } from "../../../UiComponents/SBDatePicker"
import { sbaAxios } from "../../../utils/sbaAxios";
import { DownloadDocument, getCSAccordion, getCSFamily,getUserPageAccess, getCSForReview, getCSStatusHistory, getCSStatusType, getClientStatementSum, getReviewersAPI, updateCSComment,insertOrUpdateReviewStatus } from "../../../../config/apiConfig";
import { useState } from "react";
import moment from "moment";
import { useEffect } from "react";
import { SBAEditor } from "../../../UiComponents/SBAEditor";
import { Accordion, Modal } from "react-bootstrap";
import { useRef } from "react";
import { SBNotify } from "../../../utils/sbNotify";
import { Tooltip } from "react-tooltip";
import { useImperativeHandle } from "react";
const date = new Date();
const reportDate = new Date(date.getFullYear(), date.getMonth(), 0);
const typesData = [
    { "StatusId": 0, "Action": "--Select--" },
    { "StatusId": 2, "Action": "Generated" },
    { "StatusId": 7, "Action": "Failed" },
    { "StatusId": 4, "Action": "Reviewed" },
    { "StatusId": 8, "Action": "Approved" },
    { "StatusId": 6, "Action": "Delete Approved" },
    { "StatusId": 3, "Action": "Published" },
    { "StatusId": 5, "Action": "Rejected" }
  ];
  
export const Review = ({csDate,setCSDate}) => {
    // const [csDate, setCSDate] = useState(reportDate);
    const [family, setFamily] = useState([]);
    const [CSFilter, setCSFilter] = useState(null);
    const [createdByDS, setcreatedByDS] = useState([]);
    const [status, setStatus] = useState([])
    const [selectedfamily, setSelectedFamily] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [CSData, setCSData] = useState([]);
    const [reviewData, setReviewData] = useState([]);
    const [CSBackUPData, setCSBackUPData] = useState([]);
    const [selectedClientSt, setSelectedClientSt] = useState(null);
    const [editComment, setEditComment] = useState(false);
    const isInitialLoad = useRef(true);
    const [accordionData, setAccordionData] = useState([]);
    const [showAccordion, setShowAccordion] = useState(true);
    const [csSummary, setCSSummary] = useState({});
    const [isDataLoading,setIsDataLoading]=useState(false);
    const [CSSaveAccess,setCSSaveAccess]=useState(false);
    const gridRef=useRef();
    useEffect(() => {
        setIsDataLoading(true);
        getCSSaveAccess();
        fetchCSForReview();
    }, [selectedfamily, selectedStatus, selectedUser, csDate]);
    useEffect(()=>{
        if(CSFilter && CSBackUPData.length>0){
            const filterData = CSBackUPData.filter(item => item.ClientStatementName.toLowerCase().includes(CSFilter?.toLowerCase()))
            setCSData(filterData);
        }
    },[CSBackUPData])
    useEffect(() => {
        if (isInitialLoad.current) {
            fetchData(getCSFamily, setFamily);
            fetchData(getCSStatusType, setStatus);
            fetchData(getReviewersAPI, setcreatedByDS);
            isInitialLoad.current = false;
        }
        document.title = `Client Statements`;
    }, []);
    useEffect(()=>{
        if(isDataLoading)
        gridRef?.current?.api?.showLoadingOverlay();      
    },[isDataLoading]);
    const getClientStatementSummary = async (date) => {
        const formattedDate=moment(date).format('yyyy-MM-DD');
        try {
            const response = await sbaAxios({ url: getClientStatementSum +formattedDate });
            return response;
        } catch (error) {

        }
    }
    const launchCommentsModal = (params) => {

        setEditComment(true);
    };
    const getAccordionData = async (csID, reportData) => {
        try {
            const res = await sbaAxios({ url: getCSAccordion + `?clientStatementId=${csID}&documentDate=${reportData}` })
            setAccordionData(res);
        } catch (error) {
            return [];
        }
    };

    const fetchData = async (url, update) => {
        try {
            const response = await sbaAxios({ url: url });
            update(response);
            if (url == getCSStatusType) {
                setSelectedStatus(response);
            }
        } catch (error) {
            console.log(error);
            update([]);
        }
    };
    const updateState = (param1, param2) => {
        param2(param1);
    };
    const fetchCSForReview = async () => {
        
        try {
            
            let url = `${getCSForReview}?reportDate=${csDate.toISOString()}`;

            if (selectedStatus.length > 0 || status.length === selectedStatus.length) {
                const statusString = selectedStatus.map(item => item.ClientStatementStatusTypeId).join(',');
                url += `&statusTypeIdList=${statusString}`;
            }
            if (selectedfamily?.FamilyId) {
                url += `&familyId=${selectedfamily.FamilyId}`;
            }
            if (selectedUser?.UserId) {
                url += `&userId=${selectedUser?.UserId}`;
            }
            const result = await sbaAxios({ url });
            const summary = await getClientStatementSummary(csDate);
            setCSSummary(summary);
            const formattedResult = result.map(item => { return { ...item, ReportDate: moment(item.ReportDate).format('MM-DD-yyyy') } });
            setCSData(formattedResult);
            setCSBackUPData(formattedResult);
            getAccordionData(formattedResult[0].ClientStatementId, csDate.toISOString());
            setSelectedClientSt(formattedResult[0]);        
            setIsDataLoading(false);
           
        }
        catch {
            setCSData([]);
            setCSBackUPData([]);
            setIsDataLoading(false);

        }
    };
    const RenderCommentBox = (params) => {
        return <><i class={params?.value?.replace(/<[^>]*>?/gm, '') ? `fa-comment fa ` : `fa-comment fa-regular`} title={params?.value?.replace(/<[^>]*>?/gm, '')} onClick={() => { launchCommentsModal(params) }} ></i></>
    };
   
    const getCSSaveAccess = async  () => {
        try {
      const CSSaveAccessPromise = sbaAxios({ url: `${getUserPageAccess}?keyName=ClientStatementSaveAccess` });
      const [ 
        CSSaveAccessResponse,
      ] = await Promise.all([ 
        CSSaveAccessPromise, 
      ]);     
      setCSSaveAccess(CSSaveAccessResponse);   
        } catch (error) {
          console.error("An error occurred:", error);
          
        }
      };
      
    const statusMapping = {
        'Published': 3,
        'Reviewed': 4,
        'Rejected': 5,
        'Delete Approved': 6,
        'Approved': 8
    };
    const ActionOnChange = (params) => {      
        const statusId = statusMapping[params.newValue];
        setCSData(prevData =>
            prevData.map(item =>
                item.ClientStatementId === params.data.ClientStatementId
                    ? { ...item, action: params.newValue }
                    : item
            )
        );
            setReviewData(prevData => {
                const currentData = Array.isArray(prevData) ? prevData : [];
          const existingItemIndex = currentData.findIndex(item => item.clientStatementId === params.data.ClientStatementId);
    
                let updatedReviewData;
    
                if (existingItemIndex !== -1) {
                    // Update the existing item
                  if (statusId !=undefined)
                  {
                    updatedReviewData = currentData.map((item, index) =>
                        index === existingItemIndex
                            ? {
                                ...item,
                                clientStatementStatusTypeId: statusId
                            }
                            : item
                    );
                        }
                } else {
                    // Add new item
                    if (statusId !=undefined)
                    {
                    updatedReviewData = [
                        ...currentData,
                        {
                            clientStatementId: params.data.ClientStatementId,
                            clientStatementStatusId: params.data.ClientStatementStatusId,
                            clientStatementStatusTypeId: statusId
                        }
                    ];
                }
                }
    
            return updatedReviewData;
        });
        };
        const reportdownload=(DocId)=>
        {
            if(DocId==0)
            {
                SBNotify({ Msg: "Document Not Mapped.", type: "error" });
            }
            else

            {
                downloadDocument(DocId);
            }
           
        }
    const reviewerColDef = [
        { headerName: "Date", field: "ReportDate" },
        { headerName: "User", field: "ModifiedByName", tooltipField: "ModifiedByName" },
        { headerName: "Batch #", field: "BatchNumId" ,type: 'rightAligned' },
        { headerName: "Frequency", field: "FrequencyName" },
        {
            headerName: "Client Statement", field: "ClientStatementName", flex: 2, minWidth: 300,
           
        },
        { headerName: "Supplemental Notes", field: "SupplementalNotes"  },
        { headerName: "Status", field: "CurrentStatus",tooltipComponent: ToolTip, tooltipField: "ClientStatementStatusId" },
        // { headerName: "Source", field: "DataSourceName" },
        { headerName: "Comments", field: "CommentDesc", cellRenderer: RenderCommentBox, floatingFilter: false, flex: 0.3 },
        {
            headerName: "Report", field: "Report", flex: 0.3, cellRenderer: (e) => {
                return <> <i class={e.data.ActivityDocumentId !== 0 ? 'far fa-file-pdf sba_hand  text-danger' : ' far fa-file-pdf sba_hand  text-dark'} style={{ fontSize: "16px" }}
                onClick={() => reportdownload(e.data.DocumentId)}></i></>
            }, floatingFilter: false
        },
        
        {
            headerName: "Action",
            field: "action", 
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values: actionData[params.data.CurrentStatus].map(option => option.Action),
                valueListGap: 10
            }),
            onCellValueChanged:ActionOnChange
        }
        
    ];
   
    const defaultColDef = {
        resizable: true, sortable: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter', minWidth: 100
    };
    const filterBasedOnCSName = (value) => {
        setCSFilter(value);
        const filterData = CSBackUPData.filter(item => item.ClientStatementName.toLowerCase().includes(value.toLowerCase()))
        setCSData(filterData);
    };
    const updateComment = async (statusID, comment) => {
        try {
            if (statusID) {
                const data = {
                    "clientStatementStatusId": statusID,
                    "clientStatementComment": comment
                }
                const response = await sbaAxios({ url: updateCSComment, data: data, method: 'post' });
                setEditComment(false);
                fetchCSForReview();
            }
        } catch (error) {

        };
    };
    const downloadDocument = (documentId) => {
        const urlBuild = DownloadDocument + btoa(documentId.toString());
        sbaAxios({ url: urlBuild }).then(response => {
            window.open(urlBuild);
        })
    };
    const expandCollapseAccordion = () => {
        if (selectedClientSt?.ClientStatementId)
            setShowAccordion(value => !value)
        else
        {
            SBNotify({ Msg: "Please Select Any Client Statement", type: "error" });
            setShowAccordion(false);
        }
    };
    const reFreshGrid = () => {
        fetchCSForReview();
        //setShowAccordion(false);
    };
    const rowDataUpdated = (params) => {
        params.api.forEachNode((node, index) => {
            if (index === 0) {
                node.setSelected(true);
            }
        });
    }

    const updateReviewStatus = () => {      
        let ifsave = true;
        const savedata = 
            {
              "reportDate": csDate,
              "clientStatements": reviewData
              }
              if (reviewData.length == 0) {
               
                SBNotify({ Msg: "Please Update the Action Column to Save Status.", type: "error" });
                ifsave=false;
            }
    
        if (ifsave) {

            sbaAxios({
                url: `${insertOrUpdateReviewStatus}`,
                method: "post",
                data: savedata
            }).then((res) => {  
                SBNotify({
                    Msg: "Client Statement Status Updated Successfully.",
                    type: "success",
                });  
                fetchCSForReview();         
            })
            .catch((error) => {
                SBNotify({ Msg: "Some Exception Occured While Updating the Status.", type: "error" });
            });
        }
        }
    return <>
        <div className="row">
            <div className="col-md-2 d-flex">
                <div className="w-100">
                    <span className="fw-medium d-block">Family</span>
                    <SBAComboBox placeholder="All" data={family} value={selectedfamily} textField="FamilyName" valueField="FamilyId" onChange={(e) => {
                        updateState(e.value, setSelectedFamily);
                        setSelectedClientSt(null);
                    }} />
                </div>
            </div>
            <div className="col-md-4 d-flex gap-4">
                <div  style={{width:'60%'}}>
                    <span className="fw-medium d-block">Client Statement</span>
                    <input type="text" className="form-control" value={CSFilter} placeholder="Please Enter..." onChange={(e) => { filterBasedOnCSName(e.target.value) }} />
                </div>
                <div style={{width:'40%'}}>
                    <span className="w-100 fw-medium d-block">Report Date</span>
                    <SBDatePicker value={moment(csDate)} onChange={(e) => { setCSDate(new Date(e)); }} />
                </div>
            </div>
            <div className="col-md-2 d-flex">
                <div className="w-100">
                    <span className="fw-medium d-block">Status</span>
                    <SBAMultiSelectCheck value={selectedStatus} onChange={(e) => { updateState(e.value, setSelectedStatus) }} data={status} textField="ClientStatementStatusTypeName" valueField="ClientStatementStatusTypeId" tags={
                        [
                            {
                                text: selectedStatus.length > 0 ? `${selectedStatus.length} items selected` : 'Please Select',
                                data: [...selectedStatus],
                            },
                        ]
                    } />
                </div>
            </div>
            <div className="col-md-2 d-flex">
                <div className="w-100">
                    <span className="fw-medium d-block">Created By</span>
                    <SBAComboBox placeholder="All" textField="Fullname" valueField="UserId"   data={createdByDS} value={selectedUser} onChange={(e) => { updateState(e.value, setSelectedUser) }} />
                </div>
            </div>
            <div className="col-md-2 d-flex  align-items-end gap-1 justify-content-end">
                <button className="p-sm-btn mx-1" onClick={() => { expandCollapseAccordion() }}>
                    <i class="fa-solid fa-magnifying-glass-plus"></i>
                </button>
                <button className="p-sm-btn mx-1" onClick={() => { reFreshGrid() }}>
                    <i class="fa-solid fa-arrows-rotate"></i>
                </button>
               {CSSaveAccess &&
                <button className="p-sm-btn mx-1" onClick={updateReviewStatus} >
                <i class="fa fa-save"></i>
                </button>
}
            </div>
        </div>
        <div className="row mt-4" style={{ height: '60vh' }}>
            <div className={showAccordion ? "col-md-8" : "col-md-12"} style={{width:showAccordion?'70%':'100%'}}>
                <a id="ClientStatementHis"> <span className="fw-semibold ">{csSummary?.TotalApprovedClientStatements ||  0 + csSummary?.TotalGeneratedClientStatements || 0} Out of {csSummary?.TotalClientStatements || 0} Completed | Filtered: {CSData.length}</span> </a>

                <div className="ag-theme-alpine pt-1 " style={{ minHeight: '100px', maxHeight: '55vh' }}>
                    <AgGridReact
                        columnDefs={reviewerColDef}
                        rowData={CSData}
                       
                        ref={gridRef}
                        defaultColDef={defaultColDef}
                        suppressScrollOnNewData
                        rowSelection="single"
                        paginationAutoPageSize={true}
                        tooltipInteraction={true}
                        pagination={true}
                        tooltipShowDelay={0}
                        tooltipHideDelay={20000}
                        onRowClicked={(e) => {
                            getAccordionData(e.data.ClientStatementId, csDate.toISOString());
                            setSelectedClientSt(e.data);
                           //setShowAccordion(true);
                        }}
                        onRowDataUpdated={rowDataUpdated}
                        singleClickEdit = {true}
                        overlayLoadingTemplate={'<div class="Loader"><div id="loading"><div><span style="--i: 1;"></span><span style="--i: 2;"></span><span style="--i: 3;"></span><span style="--i: 4;"></span><span style="--i: 5;"></span><span style="--i: 6;"></span><span style="--i: 7;"></span><span style="--i: 8;"></span><span style="--i: 9;"></span><span style="--i: 10;"></span></div></div></div>'}
                    />
                </div>
            </div>
            <>
                <div className={showAccordion ? "col-md-4" : "d-none"}  style={{width:showAccordion?'30%':'0%'}}>
                    {selectedClientSt?.ClientStatementId ? <> <span className="fw-semibold  d-block"> {selectedClientSt?.ClientStatementName}</span>
                        <div style={{ minHeight: '100px', maxHeight: '55vh' }} className="pt-1">
                            <ReviewAccordion data={accordionData} clientStatement={selectedClientSt} />
                        </div>
                    </> : <><span className="fw-semibold  d-block">Please Select Any Client Statement to View </span></>}
                </div>
            </>
        </div>
        <CommentModal showModal={editComment} ClientStatement={selectedClientSt} setShowModal={setEditComment} closeModal={() => { setEditComment(false) }} updateComment={updateComment} />
        <Tooltip anchorSelect="#ClientStatementHis" clickable place="right-end" className="p-2" style={{backgroundColor:'#3C5F7A'}}>
        <div className="ag-theme-alpine pt-1 " style={{ width: '280px', height: '400px' }}>
            <AgGridReact
                columnDefs={[
                    { headerName: 'Status Name', field: 'ClientStatementStatusType' },
                    { headerName: 'Record Count', field: 'RecordCount' , flex:1}
                ]}
                rowData={csSummary?.ClientStatementStatusSummary || []}
                ref={null}
                defaultColDef={{ flex: 1 }}
                suppressScrollOnNewData
            />
        </div>
        </Tooltip>
    </>
};

const CommentModal = ({ showModal, ClientStatement, setShowModal, closeModal, updateComment }) => {
    const [comment, setComment] = useState(ClientStatement?.CommentDesc);
    const [csID, setcsID] = useState(ClientStatement?.ClientStatementStatusId);
    useEffect(() => {
        setComment(ClientStatement?.CommentDesc);
        setcsID(ClientStatement?.ClientStatementStatusId);
    }, [ClientStatement])
    return <><Modal show={showModal}>
        <Modal.Header closeButton onClick={closeModal}>
            <Modal.Title>
                {'Add / View Comment'}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <><SBAEditor onChange={(e) => { setComment(e.html) }}
                defaultContent={comment}
                editorHeight={300}
                setContent={setComment}
            /></>
        </Modal.Body>
        <Modal.Footer>
            <button className="s-sm-btn mx-1" onClick={closeModal}>
                Cancel
            </button>
            <button
                className="p-sm-btn mx-1"
                onClick={() => { updateComment(csID, comment) }}
            >
                Update
            </button>
        </Modal.Footer>
    </Modal></>
};
const ReviewAccordion = ({ data, clientStatement }) => {
    const [accData, setAccData] = useState({});
    const gridRef=useRef();
    useEffect(() => {
        const apiData=fromattedData(data);
        const formattedData= {'Client Statement':apiData["ClientStatement"] || [],
        'Manager Estimates':apiData["Manager Estimates"] || [],
        'Manager Statement':apiData["Manager Statement"] || [],
        'Manager Transactions':apiData["Manager Transactions"] || [],
    }
        setAccData(formattedData);
    }, [data]);
    const PDFCellrender = (params) => {
        return <i class="far fa-file-pdf text-danger" style={{ fontSize: "16px" }} onClick={() => { downloadDocument(params.value) }}></i>
    };
    const colDef = [
        { field: 'DocumentName', headerName: 'Document Name', tooltipField: 'DocumentName' },
        { field: 'DocumentDate', headerName: 'Date', valueFormatter: (e) => { return moment(e.value).format('MM/DD/yyyy') } },
        { field: 'DocumentId', headerName: 'Report', cellRenderer: PDFCellrender }
    ];
    const downloadDocument = (documentId) => {
        const urlBuild = DownloadDocument + btoa(documentId.toString());
        sbaAxios({ url: urlBuild }).then(response => {
            window.open(urlBuild);
        })
    }
    return <>
        <Accordion defaultActiveKey={['0']}  >
            {Object.entries(accData).map((item, index) => {
                const [key, value] = item;
                return <Accordion.Item eventKey={index}>
                    <Accordion.Header>{key}</Accordion.Header>
                    <Accordion.Body>
                        {value.length>0 ? <div className="ag-theme-alpine" style={{ maxHeight: '45vh' , minHeight:'150px' }}>
                            <AgGridReact
                                rowData={[...value]}
                                columnDefs={colDef}
                                defaultColDef={{ flex: 1 }}
                                tooltipShowDelay={500}
                                enableBrowserTooltips
                                overlayNoRowsTemplate={'<span aria-live="polite" aria-atomic="true";pos>No data Available!</span>'}
                                ref={gridRef}
                            /> 
                        </div>: <div className="text-center">No Record Found </div>}
                    </Accordion.Body>
                </Accordion.Item>
            })}
        </Accordion>
    </>
};
// const StatusEditor=({showModal,setShowModal , })=>{
//     return <Modal show={showModal}>
//     <Modal.Header closeButton onClick={setShowModal(false)}>
//         <Modal.Title>
//             {'update Status'}
//         </Modal.Title>
//     </Modal.Header>
//     <Modal.Body>
//         <><SBAComboBox onChange={(e) => { setComment(e.html) }}
//             defaultContent={comment}
//             editorHeight={300}
//             setContent={setComment}
//         /></>
//     </Modal.Body>
//     <Modal.Footer>
//         <button className="s-sm-btn mx-1" onClick={closeModal}>
//             Cancel
//         </button>
//         <button
//             className="p-sm-btn mx-1"
//             onClick={() => { updateComment(csID, comment) }}
//         >
//             Update
//         </button>
//     </Modal.Footer>
// </Modal>
// }
function fromattedData(data) {
    const segeratedValue= data.reduce((acc, doc) => {
        const categoryId = doc.DocumentCategoryName;
        if (!acc[categoryId]) {
            acc[categoryId] = [];
        }
        acc[categoryId].push(doc);
        return acc;
    }, {});
    return segeratedValue
};


const ToolTip = (props) => {
    const [rowData, setRowData] = useState([]);
    useEffect(() => {
        sbaAxios({ url: getCSStatusHistory + props.value }).then(res => { setRowData(res) })
    }, [props]);
    const colDef = [
        { field: 'StatusDate', headerName: 'Date' , tooltipValueGetter:(e)=>moment(e.value).format('MM/DD/YYYY') , valueFormatter:(e)=>moment(e.value).format('MM/DD/YYYY') , minWidth:100},
        { field: 'ClientStatementStatusType', headerName: 'Status',tooltipField:'ClientStatementStatusType' },
        { field: 'UserName', headerName: 'Name' ,tooltipField:'UserName' },
    ]
    return <div className="ag-theme-alpine" style={{ width: '400px' ,pointerEvents:'auto' ,height:'500px'}}>
        <AgGridReact
            rowData={rowData}
            columnDefs={colDef}
            defaultColDef={{ flex: 1 }}
            enableBrowserTooltips
        ></AgGridReact>
    </div>
};
const actionData = {
    Processing:[],
    Generated: [
        { "StatusId": 0, "Action": "--Select--" },
        { "StatusId": 4, "Action": "Reviewed" },
        { "StatusId": 8, "Action": "Approved" },
        { "StatusId": 5, "Action": "Rejected" }

    ],
    Reviewed:[{ "StatusId": 0, "Action": "--Select--" },
    { "StatusId": 5, "Action": "Rejected" },
    { "StatusId": 8, "Action": "Approved" },
    { "StatusId": 3, "Action": "Published" } 
    ],
    Published: [
        { "StatusId": 0, "Action": "--Select--" },
        { "StatusId": 6, "Action": "Delete Approved" },
    ],
    Approved: [
        { "StatusId": 0, "Action": "--Select--" },
        { "StatusId": 3, "Action": "Published" },
        { "StatusId": 2, "Action": "Delete Approved" }],
    Rejected: [],
    "Delete Approved": [],
};

